import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
  RowVisibility,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { useLocationsOptions } from "./useLocationsOptions";
import { useActivityLocations } from "./useActivityLocations";
import { useTaskTypeFilterConfig } from "./useTaskTypeFilterConfig";
import { LOCATIONS_ID, TASK_TYPE_ID } from "../constants/filterIds";

export function useLocationsFilter(
  filterValues: FilterValue[]
): MultiSelectFilter {
  const { t } = useTranslation();
  const defaultValue = {
    filterId: LOCATIONS_ID,
    value: [],
  };

  const { hasConfig, config } = useTaskTypeFilterConfig(
    LOCATIONS_ID,
    filterValues
  );
  const taskTypeValue = filterValues.find(
    ({ filterId }) => filterId === TASK_TYPE_ID
  );
  const taskTypeValueValue = (taskTypeValue as StringFilterValue)?.value ?? "";

  let enabled: boolean;

  if (hasConfig) {
    // Config found - use it (takes precedence)
    enabled = config !== null;
  } else {
    // No config found - use existing logic unchanged
    enabled =
      taskTypeValueValue === "productIssue" ||
      taskTypeValueValue === "PQR" ||
      taskTypeValueValue === "mfaq" ||
      taskTypeValueValue === "custom" ||
      taskTypeValueValue === "main" ||
      taskTypeValueValue === "planned" ||
      taskTypeValueValue === "testbuyV1";
  }

  const { data: taskLocations, isFetching } = useActivityLocations(
    taskTypeValueValue,
    "",
    enabled
  );

  const options = useLocationsOptions(taskTypeValueValue, taskLocations ?? []);

  return {
    inputType: InputType.MultiSelect,
    filterType: FilterType.Filter,
    id: LOCATIONS_ID,
    title: t("location3String"),
    options,
    enabled,
    defaultValue,
    showSearch: true,
    rowVisibility: RowVisibility.PillOnly,
    noResultsTitle: t("noLocationsString"),
    noResultsDescription: t("noLocationsAvailableTaskTypeString"),
    isFetching,
  };
}
